import { onMounted as E, onBeforeUnmount as p, ref as i } from "vue";
import { FOCUSOUT_PREVENTED as F, FOCUSOUT_PREVENTED_OPTS as w } from "./index761.js";
import { focusElement as T } from "./index566.js";
const a = i(), u = i(0), d = i(0);
let r = 0;
const N = (e) => {
  const n = [], o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (t) => {
      const s = t.tagName === "INPUT" && t.type === "hidden";
      return t.disabled || t.hidden || s ? NodeFilter.FILTER_SKIP : t.tabIndex >= 0 || t === document.activeElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; o.nextNode(); ) n.push(o.currentNode);
  return n;
}, m = (e, n) => {
  for (const o of e)
    if (!y(o, n)) return o;
}, y = (e, n) => {
  if (process.env.NODE_ENV === "test") return !1;
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (n && e === n) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}, k = (e) => {
  const n = N(e), o = m(n, e), t = m(n.reverse(), e);
  return [o, t];
}, S = (e) => e instanceof HTMLInputElement && "select" in e, b = (e, n) => {
  if (e) {
    const o = document.activeElement;
    T(e, { preventScroll: !0 }), d.value = window.performance.now(), e !== o && S(e) && n && e.select();
  }
};
function f(e, n) {
  const o = [...e], t = e.indexOf(n);
  return t !== -1 && o.splice(t, 1), o;
}
const L = () => {
  let e = [];
  return {
    push: (t) => {
      const s = e[0];
      s && t !== s && s.pause(), e = f(e, t), e.unshift(t);
    },
    remove: (t) => {
      var s, l;
      e = f(e, t), (l = (s = e[0]) == null ? void 0 : s.resume) == null || l.call(s);
    }
  };
}, C = (e, n = !1) => {
  const o = document.activeElement;
  for (const t of e)
    if (b(t, n), document.activeElement !== o) return;
}, I = L(), O = () => u.value > d.value, c = () => {
  a.value = "pointer", u.value = window.performance.now();
}, v = () => {
  a.value = "keyboard", u.value = window.performance.now();
}, P = () => (E(() => {
  r === 0 && (document.addEventListener("mousedown", c), document.addEventListener("touchstart", c), document.addEventListener("keydown", v)), r++;
}), p(() => {
  r--, r <= 0 && (document.removeEventListener("mousedown", c), document.removeEventListener("touchstart", c), document.removeEventListener("keydown", v));
}), {
  focusReason: a,
  lastUserFocusTimestamp: u,
  lastAutomatedFocusTimestamp: d
}), U = (e) => new CustomEvent(F, {
  ...w,
  detail: e
});
export {
  U as createFocusOutPreventedEvent,
  C as focusFirstDescendant,
  I as focusableStack,
  k as getEdges,
  m as getVisibleElement,
  O as isFocusCausedByUserEvent,
  y as isHidden,
  N as obtainAllFocusableElements,
  b as tryFocus,
  P as useFocusReason
};
